export const FETCH_REVIEWS = 'review/FETCH_REVIEWS';
export const FETCH_REVIEWS_SUCCESS = 'review/FETCH_REVIEWS_SUCCESS';
export const FETCH_REVIEWS_FAILED = 'review/FETCH_REVIEWS_FAILED';
export const SET_REVIEWS_PARAMS = 'review/SET_REVIEWS_PARAMS';
export const CREATE_REVIEW = 'review/CREATE_REVIEW';

export const SET_REVIEWS_STATS = 'review/SET_REVIEWS_STATS';
export const CLEAN_LIST_OF_REVIEWS = 'review/CLEAN_LIST_OF_REVIEWS';
